import { Check } from "@mui/icons-material";
import clsx from "clsx";

interface Props {
  currentStep: number;
  steps: string[];
}

export function StepsProgress(props: Props) {
  const { currentStep, steps } = props;

  return (
    <ol className="relative mx-auto mb-10 flex w-full max-w-xl items-start justify-between">
      <div
        className="absolute left-[12%] right-[12%] top-6 h-0.5 bg-border"
        aria-hidden="true"
      />
      {steps.map((step, index) => {
        const isCompleted = currentStep > index + 1;
        const isCurrentStep = currentStep === index + 1;
        return (
          <li
            key={`steps-${step}`}
            className="relative z-10 flex flex-1 flex-col items-center gap-2"
          >
            <div
              className={clsx(
                "flex h-12 w-12 items-center justify-center rounded-full border-2 font-bold",
                isCompleted
                  ? "border-primary bg-primary text-white"
                  : isCurrentStep
                    ? "border-primary bg-white text-primary shadow-sm"
                    : "border-border bg-white text-muted"
              )}
              aria-current={isCurrentStep ? "step" : undefined}
            >
              {isCompleted ? (
                <Check aria-hidden="true" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <p
              className={clsx(
                "text-center text-sm font-semibold",
                isCurrentStep ? "text-gray" : "text-muted"
              )}
            >
              {step}
            </p>
          </li>
        );
      })}
    </ol>
  );
}
